<div class="modal fade" id="keysModal" tabindex="-1" role="dialog" aria-labelledby="keysModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <!-- <div class="modal-content">
            <div class="modal-header">
                @*<h5 class="modal-title" id="keysModalLabel">Keys</h5>*@
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" id="keysModalBody">
                <ul class="nav nav-pills">
                    <li class="active"><a data-toggle="tab" href="#key1">Lab Type Key</a></li>
                    <li><a data-toggle="tab" href="#key2" title="Schedule Key">Schedule Key</a></li>
                    <li><a data-toggle="tab" href="#key3" title="Accreditation Key">Accreditation Key</a></li>
                    <li><a data-toggle="tab" href="#key4" title="Proficiency Tests">Proficiency Tests</a></li>
                    <li><a data-toggle="tab" href="#key5" title="Specialties">Specialties</a></li>
                    <li><a data-toggle="tab" href="#key6" title="Survey Types">Survey Types</a></li>
                    <li><a data-toggle="tab" href="#key7" title="Complexity">Complexity</a></li>
                    <li><a data-toggle="tab" href="#key8" title="Certificate Type">Certificate Type</a></li>
                </ul>
                <div class="tab-content">
                    <div id="key1" class="tab-pane fade in active">
                        <h3>Lab Type Key</h3>
                        <table width="95%" cellpadding="0" cellspacing="0" border="0" aria-describedby="Keys">
                            <thead>
                                <tr class="keyHeader">
                                    <th scope="col">Lab Type</th>
                                    <th scope="col">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                @foreach (var value in Keys.GetLabTypeKeys())
                                {
                                    <tr>
                                        <td width="10%">@value.Item1</td>
                                        <td width="90%">@value.Item2</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div id="key2" class="tab-pane fade">
                        <h3>Schedule Key</h3>
                        <table width="95%" cellpadding="0" cellspacing="0" border="0" aria-describedby="Keys2">
                            <thead>
                                <tr class="keyHeader">
                                    <th scope="col">Lab Type</th>
                                    <th scope="col">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                @foreach (var value in Keys.GetScheduleKeys())
                                {
                                    <tr>
                                        <td width="10%">@value.Item1</td>
                                        <td width="90%">@value.Item2</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div id="key3" class="tab-pane fade">
                        <h3>Accreditation Key</h3>
                        <table width="95%" cellpadding="0" cellspacing="0" border="0" aria-describedby="Keys3">
                            <tbody>
                                @foreach (var value in Keys.GetAccreditationKeys())
                                {
                                    <tr>
                                        <td width="5%">@value.Item1</td>
                                        <td width="45%">@value.Item2</td>
                                        <td width="45%">@value.Item3</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div id="key4" class="tab-pane fade">
                        <h3>Proficiency Tests</h3>
                        <table id="ptTable" class="table table-striped" aria-describedby="Keys4">
                            <thead>
                                <tr class="keyHeader">
                                    <th scope="col">PT Test</th>
                                    <th scope="col">Specialty</th>
                                    <th scope="col">Sub Specialty</th>
                                    <th scope="col">T Code</th>
                                    <th scope="col">T ID</th>
                                    <th scope="col">Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                @foreach (var tests in keys.GetProficiencyTests())
                                {
                                    <tr>
                                        <td>@tests.PtTest</td>
                                        <td>@tests.Specialty</td>
                                        <td>@tests.SubSpecialty</td>
                                        <td>@tests.TCode</td>
                                        <td>@tests.TId</td>
                                        <td>@tests.Code</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div id="key5" class="tab-pane fade">
                        <h3>Specialties</h3>
                        <table width="95%" cellpadding="0" cellspacing="0" border="0" aria-describedby="Keys5">
                            <thead>
                                <tr class="keyHeader">
                                    <th scope="col">T CD</th>
                                    <th scope="col">Specialty</th>
                                    <th scope="col">Sub Specialty</th>
                                    <th scope="col">PT</th>
                                </tr>
                            </thead>
                            <tbody>
                                @foreach (var test in keys.GetSpecialties())
                                {
                                    <tr>
                                        <td>@test.TCd</td>
                                        <td>@test.Specialty</td>
                                        <td>@test.SubSpecialty</td>
                                        <td>@test.Pt</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div id="key6" class="tab-pane fade">
                        <h3>Survey Types</h3>
                        <table width="95%" cellpadding="0" cellspacing="0" border="0" aria-describedby="Keys6">
                            <tbody>
                                @foreach (var value in Keys.GetSurveyTypes())
                                {
                                    <tr>
                                        <td width="10%">@value.Item1</td>
                                        <td width="90%">@value.Item2</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div id="key7" class="tab-pane fade">
                        <div class="col-md-12"><h3>Complexity</h3></div>
                        @foreach (var value in Keys.GetComplexity())
                        {
                            <div class="col-md-12">@value.Item1 &nbsp; - &nbsp; @value.Item2</div>
                        }
                    </div>
                    <div id="key8" class="tab-pane fade">
                        <div class="col-md-12"><h3>Certificate Type</h3></div>
                        @foreach (var value in Keys.GetCertificateTypes())
                        {
                            <div class="col-md-12">@value.Item1 &nbsp; - &nbsp; @value.Item2</div>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div> -->
    </div>
</div>
